import { useContext } from 'react';
import type { UserContextExtendedProps } from '../components/UserProvider/UserContext';
import { UserContextExtended } from '../components/UserProvider/UserContext';

export default function useUserExtended(): UserContextExtendedProps {
  return useContext(UserContextExtended);
}
